@if (cartService.isOpen()) {
  <div class="cart-backdrop" (click)="cartService.close()"></div>

  <div class="cart-drawer">
    <!-- Header -->
    <div class="cart-drawer__header">
      <div class="cart-drawer__title-row">
        <h2 class="cart-drawer__title">Cart</h2>
        @if (cartService.count() > 0) {
          <span class="cart-drawer__count">{{ cartService.count() }}</span>
        }
      </div>
      <button type="button" class="cart-drawer__close" (click)="cartService.close()" aria-label="Close cart">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    @if (cartService.items().length === 0) {
      <!-- Empty state -->
      <div class="cart-drawer__empty">
        <i class="fa-solid fa-bag-shopping cart-drawer__empty-icon"></i>
        <p class="cart-drawer__empty-text">Your cart is empty</p>
        <p class="cart-drawer__empty-sub">Browse products and add them here</p>
      </div>
    } @else {
      <!-- Items -->
      <div class="cart-drawer__body">
        @for (group of cartService.storeGroups(); track group.storeUsername) {
          <div class="cart-group">
            <div class="cart-group__store">
              <i class="fa-brands fa-instagram cart-group__ig"></i>
              <a [routerLink]="['/stores', group.storeUsername]" class="cart-group__store-name" (click)="cartService.close()">
                &#64;{{ group.storeUsername }}
              </a>
            </div>

            @for (item of group.items; track item.productId) {
              <div class="cart-item">
                <a [routerLink]="['/stores', item.storeUsername, 'products', item.productId]" (click)="cartService.close()" class="cart-item__img-wrap">
                  @if (item.image) {
                    <img [src]="item.image" [alt]="item.name" class="cart-item__img" />
                  } @else {
                    <div class="cart-item__img-placeholder"><i class="fa-solid fa-image"></i></div>
                  }
                </a>

                <div class="cart-item__info">
                  <a [routerLink]="['/stores', item.storeUsername, 'products', item.productId]" (click)="cartService.close()" class="cart-item__name">
                    {{ item.name }}
                  </a>
                  <p class="cart-item__price">₹{{ item.price }}</p>

                  <div class="cart-item__qty-row">
                    <div class="cart-item__qty">
                      <button type="button" class="cart-item__qty-btn" (click)="decrement(item.productId, item.quantity)" aria-label="Decrease">−</button>
                      <span class="cart-item__qty-val">{{ item.quantity }}</span>
                      <button type="button" class="cart-item__qty-btn" (click)="increment(item.productId, item.quantity)" aria-label="Increase">+</button>
                    </div>
                    <button type="button" class="cart-item__remove" (click)="cartService.removeItem(item.productId)" aria-label="Remove">
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              </div>
            }

            <div class="cart-group__footer">
              <div class="cart-group__subtotal">
                <span>Subtotal</span>
                <span>₹{{ group.subtotal }}</span>
              </div>
              <a [href]="whatsappLink(group)" target="_blank" rel="noopener noreferrer" class="cart-group__order-btn">
                <i class="fa-brands fa-whatsapp"></i>
                Order from {{ group.storeName }}
              </a>
            </div>
          </div>
        }
      </div>

      <!-- Footer -->
      <div class="cart-drawer__footer">
        <div class="cart-drawer__total">
          <span>Total</span>
          <span>₹{{ cartService.total() }}</span>
        </div>
        <button type="button" class="cart-drawer__clear" (click)="cartService.clear()">
          Clear cart
        </button>
      </div>
    }
  </div>
}
